export default function CHome() {
  return <h2>C Home</h2>;
}
